export default __webpack_public_path__ + "static/media/img-slider-smart-signage-5.96dcfb87.png";